"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddScoresToTeamsBodyToJSON = exports.AddScoresToTeamsBodyFromJSONTyped = exports.AddScoresToTeamsBodyFromJSON = void 0;
function AddScoresToTeamsBodyFromJSON(json) {
    return AddScoresToTeamsBodyFromJSONTyped(json, false);
}
exports.AddScoresToTeamsBodyFromJSON = AddScoresToTeamsBodyFromJSON;
function AddScoresToTeamsBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'tournamentID': json['tournamentID'],
    };
}
exports.AddScoresToTeamsBodyFromJSONTyped = AddScoresToTeamsBodyFromJSONTyped;
function AddScoresToTeamsBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'tournamentID': value.tournamentID,
    };
}
exports.AddScoresToTeamsBodyToJSON = AddScoresToTeamsBodyToJSON;
